import { gql } from '@apollo/client'

export const REGISTER_INTEREST = gql`
  mutation Teams_SignUpModal_RegisterInterest(
    $name: String!
    $from: String!
    $body: String!
    $subject: String!
  ) {
    teamsRegisterInterest(name: $name, from: $from, subject: $subject, body: $body)
  }
`
